import axios, { Axios } from "axios";

export type ResponseBaseType<T> = Promise<
  | {
      statusCode: 0;
      data?: never;
      errors: [ResponseErrorType];
    }
  | {
      statusCode: 1;
      data: T;
      errors?: never;
    }
>;

type ResponseErrorType = {
  errorCode: number;
  responseMessage: string;
};

export let ApiInstance: Axios;
export function createAPIInstance(baseURL: string, unauthenticatedCallback: () => void) {
  ApiInstance = axios.create({
    baseURL,
  });

  ApiInstance.interceptors.request.use(
    (req) => {
      const token = localStorage.getItem("accessToken");

      if (!req.headers.get("Content-Type")) {
        req.headers.set("Content-Type", "application/json");
      }

      if (token) {
        req.headers.set("accessToken", token);
      }

      return req;
    },
    (error) => Promise.reject(error),
  );

  ApiInstance.interceptors.response.use(
    // @ts-expect-error: fix me
    (response) => {
      return {
        statusCode: response.data.statusCode,
        data: response.data.responseData,
      };
    },
    (error) => {
      if (error.response) {
        if (error.response.status === 401) {
          unauthenticatedCallback();
        }

        // ensure `errors` is an array for backwards compatibility
        if (error.response.data?.error instanceof Array) {
          return {
            statusCode: 0,
            errors: error.response.data?.error,
          };
        } else {
          return {
            statusCode: 0,
            errors: [error.response.data?.error],
          };
        }
      }

      if (error.message === "Network Error") {
        const networkError = {
          errorCodeList: ["NETWORK"],
        };

        return Promise.reject(networkError);
      } else if (error.message === `timeout of 3 ms exceeded`) {
        const timeoutError = {
          errorCodeList: ["TIMEOUT"],
        };

        return Promise.reject(timeoutError);
      }

      return Promise.reject(error);
    },
  );
}
